var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("h5", [_vm._v("Courses")]),
        _vm._v(" "),
        _c("CourseSearchCards", {
          attrs: {
            courses: _vm.firstRowOfCourses,
            queryID: _vm.queryID,
            startPosition: 1,
            "in-header": _vm.inHeader,
            mobile: _vm.mobile,
            "is-staff-user": _vm.isStaffUser
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.viewRemainingCourses
      ? _c(
          "div",
          [
            _c("CourseSearchCards", {
              attrs: {
                courses: _vm.remainingCourses,
                queryID: _vm.queryID,
                startPosition: _vm.numCoursesRow + 1,
                "in-header": _vm.inHeader,
                mobile: _vm.mobile,
                "is-staff-user": _vm.isStaffUser
              }
            })
          ],
          1
        )
      : _vm.numCoursesTotal > 4
      ? _c("div", { staticClass: "see-all" }, [
          _c("span", { on: { click: _vm.viewAll } }, [
            _vm._v("\n      See all\n      "),
            _c("span", { staticClass: "b-sprite-courses-chevron-3 inline" })
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }